(() => {
  if (customElements.get('oilogic-testimonial-video')) return;

/*
 * <oilogic-testimonial-video> — custom play/pause + mute controls over a muted
 * inline <video>. Progressive enhancement: the <video> renders server-side; this
 * element only wires the overlay buttons. State is reflected on the host as
 * data-playing / data-muted so the CSS can swap the button icons.
 */
class OilogicTestimonialVideo extends HTMLElement {
  #ctrl = new AbortController();

  connectedCallback() {
    this.video = this.querySelector('video');
    this.playBtn = this.querySelector('[data-tp-play]');
    this.muteBtn = this.querySelector('[data-tp-mute]');
    if (!this.video) return;

    const { signal } = this.#ctrl;
    this.playBtn?.addEventListener('click', () => this.#togglePlay(), { signal });
    this.muteBtn?.addEventListener('click', () => this.#toggleMute(), { signal });
    this.video.addEventListener('play', () => { this.dataset.playing = ''; }, { signal });
    this.video.addEventListener('pause', () => { this.removeAttribute('data-playing'); }, { signal });

    this.toggleAttribute('data-muted', this.video.muted);
  }

  disconnectedCallback() {
    this.video?.pause();
    this.#ctrl.abort();
  }

  #togglePlay() {
    if (this.video.paused) this.video.play(); else this.video.pause();
  }

  #toggleMute() {
    this.video.muted = !this.video.muted;
    this.toggleAttribute('data-muted', this.video.muted);
  }
}

customElements.define('oilogic-testimonial-video', OilogicTestimonialVideo);
})();
